import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import { format } from "date-fns";

export default function UncheckInspectionDialog({
    open,
    onClose,
    inspection,
    canUncheck = true,
    onConfirm,
}) {
    const [saving, setSaving] = useState(false);

    if (!inspection) return null;

    const checkedBy =
        inspection.created_by_detail?.full_name ||
        inspection.created_by_detail?.username ||
        "Someone";
    const checkedDate = inspection.created
        ? format(new Date(inspection.created), "MM/dd/yyyy")
        : "";
    const checkedTime = inspection.created
        ? format(new Date(inspection.created), "h:mm a")
        : "";

    const handleConfirm = async () => {
        setSaving(true);
        try {
            await onConfirm(inspection);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={saving ? undefined : onClose}
            aria-labelledby="uncheck-dialog-title"
            aria-describedby="uncheck-dialog-description"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="uncheck-dialog-title">
                {canUncheck ? "Uncheck This Period?" : "Inspection Details"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="uncheck-dialog-description">
                    {canUncheck
                        ? `Checked by ${checkedBy}${checkedDate ? ` on ${checkedDate}` : ""}${checkedTime ? ` at ${checkedTime}` : ""}. Are you sure you want to recheck it?`
                        : `Checked by ${checkedBy}${checkedDate ? ` on ${checkedDate}` : ""}${checkedTime ? ` at ${checkedTime}` : ""}.`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {canUncheck ? (
                    <>
                        <Button
                            onClick={onClose}
                            color="primary"
                            disabled={saving}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            color="error"
                            variant="contained"
                            disabled={saving}
                            autoFocus
                        >
                            {saving ? "Unchecking…" : "Uncheck"}
                        </Button>
                    </>
                ) : (
                    <Button onClick={onClose} color="primary" autoFocus>
                        Close
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
